import { useState, useCallback } from "react";
import { getConversationDocumentsApi } from "../../api";
import { FileStatus } from "../../components/DocumentUploadDialog/DocumentUploadDialog";

export const useFileUpload = () => {
  const [uploadedFiles, setUploadedFiles] = useState<FileStatus[]>([]);
  const [uploadedFilesByConvId, setUploadedFilesByConvId] = useState<{
    [key: string]: FileStatus[];
  }>({});

  const fetchConversationFiles = useCallback(
    async (conversationId: string): Promise<FileStatus[]> => {
      try {
        const fetchedUploadedFiles =
          await getConversationDocumentsApi(conversationId);
        const formattedFiles: FileStatus[] = fetchedUploadedFiles.map(
          (doc) => ({
            status: "completed",
            file: {
              name: doc.name,
            },
            uploadedFileName: doc.name,
            progress: 100,
            creationTime: doc.creation_time
              ? new Date(doc.creation_time)
              : undefined,
          }),
        );

        // Cache files by conversation ID
        setUploadedFilesByConvId((prevState) => ({
          ...prevState,
          [conversationId]: formattedFiles,
        }));
        setUploadedFiles(formattedFiles);

        return formattedFiles;
      } catch (error) {
        console.error("Error fetching conversation files:", error);
        return [];
      }
    },
    [],
  );

  return {
    uploadedFiles,
    uploadedFilesByConvId,
    fetchConversationFiles,
    setUploadedFiles,
  };
};
